import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "item-content-changed__header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "heading-level-3" }, "updated Task", -1)
const _hoisted_3 = { class: "body-text-large-400" }
const _hoisted_4 = { class: "item-content-changed__content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "item-content-changed__label" }, "Before:", -1)
const _hoisted_6 = { class: "item-content-changed__description" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "item-content-changed__label" }, "Spec:", -1)
const _hoisted_8 = { class: "item-content-changed__description" }
const _hoisted_9 = { class: "item-content-changed__content" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "item-content-changed__label" }, "After:", -1)
const _hoisted_11 = { class: "item-content-changed__description" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "item-content-changed__label" }, "Spec:", -1)
const _hoisted_13 = { class: "item-content-changed__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommentOwner = _resolveComponent("CommentOwner")!
  const _component_TaskItem = _resolveComponent("TaskItem")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_ControlButtons = _resolveComponent("ControlButtons")!
  const _component_CustomModal = _resolveComponent("CustomModal")!

  return (_openBlock(), _createBlock(_component_CustomModal, {
    id: `item-task-changed-${_ctx.comment.id}`,
    modalClass: "custom-modal_item-task",
    width: "75%"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_CommentOwner, {
          user: _ctx.comment.owner,
          userNameWeight: "400"
        }, {
          username: _withCtx(({ userName }) => [
            _createTextVNode(_toDisplayString(userName) + " ", 1),
            _hoisted_2
          ]),
          _: 1
        }, 8, ["user"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.comment.timeAndDateReversed), 1)
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("span", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_TaskItem, {
          task: _ctx.beforeTask,
          isOpen: true,
          availableTaskTypes: _ctx.availableTaskTypes,
          class: "pointer-none"
        }, null, 8, ["task", "availableTaskTypes"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Editor, {
            id: "beforeTask",
            type: "read",
            value: _ctx.beforeTask.structuredDescription?.html ?? '',
            targetConfig: _ctx.targetConfig,
            referenceFileTargetConfig: _ctx.targetConfig,
            extensions: _ctx.extensions
          }, null, 8, ["value", "targetConfig", "referenceFileTargetConfig", "extensions"])
        ]),
        (_ctx.hasSpec)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Editor, {
                  id: "beforeTaskSpec",
                  type: "read",
                  value: _ctx.beforeTask.spec?.html ?? '',
                  targetConfig: _ctx.targetConfig,
                  referenceFileTargetConfig: _ctx.targetConfig,
                  extensions: _ctx.extensions
                }, null, 8, ["value", "targetConfig", "referenceFileTargetConfig", "extensions"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_TaskItem, {
          task: _ctx.afterTask,
          isOpen: true,
          class: "pointer-none"
        }, null, 8, ["task"]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Editor, {
            id: "afterTask",
            type: "read",
            value: _ctx.afterTask.structuredDescription?.html ?? '',
            targetConfig: _ctx.targetConfig,
            referenceFileTargetConfig: _ctx.targetConfig,
            extensions: _ctx.extensions
          }, null, 8, ["value", "targetConfig", "referenceFileTargetConfig", "extensions"])
        ]),
        (_ctx.hasSpec)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Editor, {
                  id: "afterTaskSpec",
                  type: "read",
                  value: _ctx.afterTask.spec?.html ?? '',
                  targetConfig: _ctx.targetConfig,
                  referenceFileTargetConfig: _ctx.targetConfig,
                  extensions: _ctx.extensions
                }, null, 8, ["value", "targetConfig", "referenceFileTargetConfig", "extensions"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(({ hide }) => [
      _createVNode(_component_ControlButtons, {
        hideCancel: true,
        onSave: hide
      }, {
        save: _withCtx(() => [
          _createTextVNode(" Ok ")
        ]),
        _: 2
      }, 1032, ["onSave"])
    ]),
    _: 1
  }, 8, ["id"]))
}